// Mock data de personas — lookup por patente del vehículo
import { PersonResponse } from '../../app/features/quoter/models/person.model';

export const MOCK_PERSONS_BY_PLATE: Record<string, PersonResponse> = {
  ABCD12: {
    rut: '12345678-5',
    fullName: 'María González Pérez',
    firstName: 'María',
    secondName: '',
    firstLastName: 'González',
    motherName: 'Pérez',
    birthDate: '1985-04-12',
    dataTreatmentAccepted: true,
  },
  XYWZ34: {
    rut: '15234567-K',
    fullName: 'Juan Carlos Soto Ramírez',
    firstName: 'Juan',
    secondName: 'Carlos',
    firstLastName: 'Soto',
    motherName: 'Ramírez',
    birthDate: '1978-11-23',
    dataTreatmentAccepted: false,
  },
  KZLX23: {
    rut: '16789012-3',
    fullName: 'Carlos Andrés Mendoza Fuentes',
    firstName: 'Carlos',
    secondName: 'Andrés',
    firstLastName: 'Mendoza',
    motherName: 'Fuentes',
    birthDate: '1990-07-15',
    dataTreatmentAccepted: true,
  },
};
